<template>
    <div class="mx-auto w-full max-w-sm rounded-md">
        <div class="flex animate-pulse space-x-4">
            <div class="size-10 rounded-full" :class="bgColor"></div>
            <div class="flex-1 space-y-6 py-1">
                <div class="h-2 rounded" :class="bgColor"></div>
                <div class="space-y-3">
                    <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-2 h-2 rounded" :class="bgColor"></div>
                        <div class="col-span-1 h-2 rounded" :class="bgColor"></div>
                    </div>
                    <div class="h-2 rounded" :class="bgColor"></div>
                    <div class="grid grid-cols-3 gap-4">
                        <div class="col-span-1 h-2 rounded" :class="bgColor"></div>
                        <div class="col-span-2 h-2 rounded" :class="bgColor"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        bgColor: {
            type: String,
            default: "bg-gray-200"
        },
    },
};
</script>
